import { render, staticRenderFns } from "./learning-edit.vue?vue&type=template&id=0cef883f&scoped=true"
import script from "./learning-edit.vue?vue&type=script&lang=ts"
export * from "./learning-edit.vue?vue&type=script&lang=ts"
import style0 from "./learning-edit.vue?vue&type=style&index=0&id=0cef883f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cef883f",
  null
  
)

export default component.exports